import React from "react";
import * as Icon from "react-feather";

const navigationConfig = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "item",
    icon: <Icon.Home size={20}/>,
    permissions: ["admin", "seller", "designer", "manager", "support", "idea"],
    navLink: "/",
  },
  {
    id: "datamerch",
    title: "Data Merch",
    type: "item",
    icon: <Icon.BarChart size={20}/>,
    permissions: ["admin", "seller", "manager", "support", "idea"],
    navLink: "/datamerch",
  },
  {
    id: "checksale",
    title: "Info Merch",
    type: "item",
    icon: <Icon.Image size={20}/>,
    permissions: ["admin", "seller", "manager", "support", "idea"],
    navLink: "/checksale",
  },
  {
    id: "management",
    title: "Management",
    type: "item",
    icon: <Icon.User size={20}/>,
    permissions: ["admin", "manager", "seller"],
    navLink: "/team",
  },
  {
    id: "log",
    title: "Logs",
    type: "item",
    icon: <Icon.List size={20}/>,
    permissions: ["admin", "seller", "manager", "support"],
    navLink: "/logs",
  }
];

export default navigationConfig;
